import React from 'react';

export function Modal({
  open,
  onClose,
  children,
  title,
  size = "md"
}: {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: React.ReactNode;
  size?: "sm" | "md" | "lg" | "xl";
}) {
  if (!open) return null;
  
  const sizeClasses = {
    sm: "max-w-md",
    md: "max-w-2xl",
    lg: "max-w-4xl",
    xl: "max-w-6xl"
  };
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/30" onClick={onClose} />
      <div className={`relative z-10 w-full ${sizeClasses[size]} rounded-2xl bg-white p-4 shadow-xl max-h-[90vh] overflow-y-auto`}>
        {title && <div className="mb-2 text-lg font-semibold">{title}</div>}
        {children}
      </div>
    </div>
  );
}


